<template>
  <div id="overlay">
    <div class="d-flex justify-content-center align-items-center" style="height: 100%;">
      <div class="error_dialog">
        <div class="error_header">
          エラー
        </div>
        <div class='error_dialog_top'>
          <div class="error_flex">
            <div class="error_wording_table">
              <div class="error_icon_aligin">
                <div class="icon_error" />
              </div>
              <div class="error_wording">{{ errorWording }}</div>
            </div>
            <div class="error_btn_padding">
              <button class="mypagebackbutton col-btn-size" @click="clickEvent">OK</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
    components: {
    },
    props: ['errorWording'],
    data () {
        return {
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {

        },
        clickEvent (){
            this.$emit('closeErrorDialog');
        }
    }
}

</script>

<style scoped>

.error_dialog {
    width: 600px;
    margin-left: 20px;
    margin-right: 20px;
}

.error_dialog_top{
    background: #FFFFFF;
    padding: 30px 30px 30px 30px;
}

.errorbackBtn {
    background-color: #C0C0C0;
    border-radius: 5px;
    text-align: center;
}

.error_wording {
    display: table-cell;
    vertical-align: middle;
    white-space: pre-line;
}

.error_btn_padding {
    text-align: center;
    padding-top: 3%;
}

.error_wording_table {
    display: table;
}

.col-btn-size{
    width: 120px;
    word-break: keep-all;
}

.error_flex {
    display: flex;
    flex-direction: column;
}

.error_icon_aligin{
    display: table-cell;
    vertical-align: middle;
}

.icon_error {
    background-size: 40px;
    height: 40px;
    width: 40px;
    float: left;
    margin: 5px;
}

@media screen and (max-width: 896px) {
    .error_dialog_top{
        width: initial;
    }

    .error_header {
        width: initial;
    }
}
</style>
